import { Job, Timecard } from '@mp/graphql/generated/graphql';

/**
 * Checks if a timecard has any Time Off jobs
 * @param timecard - The timecard to check
 * @returns true if the timecard contains any jobs with job_type === 'time_off'
 */
export const hasTimeOffJobs = (timecard: Timecard): boolean => {
  return timecard.jobs?.some((job: Job) => job.job_type === 'time_off') || false;
};
